
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import { ControllerRenderProps, Control } from 'react-hook-form';
import TermsDialog from './TermsDialog';

interface TermsCheckboxProps {
  control?: Control<any>;
  name?: string;
  label?: string;
  required?: boolean;
  field?: ControllerRenderProps<any, string>;
}

const TermsCheckbox = ({ 
  control, 
  name = "termsAccepted", 
  label = "Terms and Conditions", 
  required = true,
  field
}: TermsCheckboxProps) => {
  if (field) {
    return (
      <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
        <FormControl>
          <Checkbox 
            checked={field.value} 
            onCheckedChange={field.onChange}
          />
        </FormControl>
        <div className="space-y-1 leading-none">
          <FormLabel>
            I agree to the{" "}
            <TermsDialog>
              <span className="text-blue-600 hover:underline cursor-pointer">
                {label.toLowerCase()}
              </span>
            </TermsDialog>{" "}
            {required && <span className="text-red-500">*</span>}
          </FormLabel>
          <FormMessage />
        </div>
      </FormItem>
    );
  }

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
          <FormControl>
            <Checkbox 
              checked={field.value} 
              onCheckedChange={field.onChange}
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel>
              I agree to the{" "}
              <TermsDialog>
                <span className="text-blue-600 hover:underline cursor-pointer">
                  {label.toLowerCase()}
                </span>
              </TermsDialog>{" "}
              {required && <span className="text-red-500">*</span>}
            </FormLabel>
            <FormMessage />
          </div>
        </FormItem>
      )}
    />
  );
};

export default TermsCheckbox;
